import { createTheme } from '@mui/material/styles';
import '@fontsource/be-vietnam-pro';
const theme = createTheme({
  palette: {
    primary: {
      main: '#295DAB',
      light: '#D7E2FF',
      dark: '#001B3F',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#006491',
      light: '#C9E6FF',
      dark: '#001E2F',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#BA1A1A',
      light: '#FFDAD6',
      dark: '#410002',
      contrastText: '#FFFFFF'
    },
    background: {
      default: '#f4f2fd'
    },
    neutral: {
      main: '#C9E6FF',
      contrastText: '#212121'
    },
    dataGridHeaderBackground: {
      main: '#E5F2FF'
    },
    iconBackgroundColor: {
      main: '#46464F'
    },
    attendanceCards: {
      main: '#ECF0FF'
    }
  },
  typography: {
    fontFamily: 'Be Vietnam Pro',
    fontSize: 14,
    fontWeightBold: 700,
    fontWeightLight: 500,
    fontWeightMedium: 600
  },
  shape: {
    borderRadius: 4
  }
});

const themeDark = createTheme({
  palette: {
    primary: {
      main: '#ABC7FF',
      light: '#004590',
      dark: '#D7E2FF',
      contrastText: '#002F66'
    },
    secondary: {
      main: '#8ACEFF',
      light: '#004C6E',
      dark: '#C9E6FF',
      contrastText: '#00344E'
    },
    error: {
      main: '#FFB4AB',
      light: '#93000A',
      dark: '#FFDAD6',
      contrastText: '#690005'
    },
    background: {
      default: '#DFD5EC'
    },
    neutral: {
      main: '#C9E6FF',
      contrastText: '#212121'
    }
  }
});

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
    dataGridHeaderBackground: Palette['primary'];
    iconBackgroundColor: Palette['primary'];

    // sidebarFontColor: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
    dataGridHeaderBackground?: PaletteOptions['primary'];
    iconBackgroundColor?: PaletteOptions['primary'];

    // sidebarFontColor?: PaletteOptions['primary'];
  }
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    attendanceCards: Palette['primary'];
  }

  interface PaletteOptions {
    attendanceCards?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Card' {
  interface CardPropsColorOverrides {
    attendanceCards: true;
  }
}

export { theme, themeDark };
